export default __webpack_public_path__ + "static/media/picture_of_king.c70e7c24.png";